/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.array.join.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ImgUpload from '@/components/ImgUpload';
import FileUpload from '@/components/FileUpload';
import Popup from "vux/src/components/popup/index.vue";
import ViewBox from "vux/src/components/view-box/index.vue";
import Cell from "vux/src/components/cell/index.vue";
import Group from "vux/src/components/group/index.vue";
import CellBox from "vux/src/components/cell-box/index.vue";
import XButton from "vux/src/components/x-button/index.vue";
import XTextarea from "vux/src/components/x-textarea/index.vue";
import XSwitch from "vux/src/components/x-switch/index.vue";
import { saveMessage } from '@/api';
export default {
  props: {
    value: {
      type: Boolean,
      required: false
    },
    orderId: String
  },
  components: {
    Popup: Popup,
    ViewBox: ViewBox,
    Cell: Cell,
    Group: Group,
    CellBox: CellBox,
    XButton: XButton,
    XTextarea: XTextarea,
    ImgUpload: ImgUpload,
    XSwitch: XSwitch,
    FileUpload: FileUpload
  },
  watch: {
    value: function value(val) {
      this.messageShow = val;
    },
    messageShow: function messageShow(val) {
      var _this = this;

      if (val) {
        this.$setLeft({
          control: true,
          onSuccess: function onSuccess() {
            _this.messageShow = false;
          }
        });
      } else {
        this.messageFields = {
          message: '',
          imgList: [],
          attachmentList: [],
          isCustomerView: false
        };
        this.$setLeft({
          control: false
        });
      }

      this.$emit('input', val);
    }
  },
  data: function data() {
    return {
      loading: false,
      messageShow: this.value,
      // 工单留言表单字段
      messageFields: {
        message: '',
        imgList: [],
        attachmentList: [],
        isCustomerView: false
      }
    };
  },
  methods: {
    checkmessage: function checkmessage() {
      if (this.trim(this.messageFields.message) === '') {
        this.$vux.toast.text('工单留言不能为空');
      }
    },
    trim: function trim(str) {
      return str.replace(/^(\s|\u00A0)+/, '').replace(/(\s|\u00A0)+$/, '');
    },
    submit: function submit() {
      var _this2 = this;

      if (this.trim(this.messageFields.message) !== '') {
        this.loading = true;
        saveMessage({
          content: this.messageFields.message,
          images: this.messageFields.imgList.join(','),
          fileUrl: this.messageFields.attachmentList.join(','),
          isCustomerView: this.messageFields.isCustomerView ? 1 : 0,
          oid: this.orderId
        }).then(function (res) {
          _this2.loading = false;

          if (res.success) {
            _this2.$vux.toast.text('保存成功');

            _this2.messageShow = false;

            _this2.$emit('on-success');
          } else {
            _this2.$vux.toast.text(res.message);
          }
        });
      } else {
        this.$vux.toast.text('工单留言不能为空');
      }
    }
  },
  creatad: function creatad() {}
};